/* eslint-disable  */
import Page from 'modules/app/components/Page'
import React, { useCallback, useEffect, useState } from 'react'
import { ReactComponent as IconSearch } from 'images/search.svg';
import { ReactComponent as IconBack } from 'images/icons/arrow-left.svg';
import { ReactComponent as IconRecent } from 'images/icons/search/recent.svg';
import { ReactComponent as IconSuggestion } from 'images/icons/search/suggestion.svg';
import { ReactComponent as IconPopular } from 'images/icons/search/popular.svg';
import { ReactComponent as IconRemove } from 'images/icons/search/remove.svg';
import { ReactComponent as IconClear } from 'images/icons/search/clear.svg';
import clsx from 'clsx';
import Input from 'components/shared/Input';
import { useNavigate, useParams } from 'react-router-dom';
import Tabs from 'components/shared/Tabs';
import useGetPopularQuerySuggestion from 'sdk/hooks/search/useGetPopularQuerySuggestion';
import useGetRecentQuerySuggestion from 'sdk/hooks/search/useGetRecentQuerySuggestion';
import useGetQuerySuggestion from 'sdk/hooks/search/useGetQuerySuggestion';
import useDeleteQuerySuggestion from 'sdk/hooks/search/useDeleteQuerySuggestion';
import styles from './Search.module.scss'
import { TabTrending } from '../components/TabTrending';
import { TabAsset } from '../components/TabAsset';
import { TabVideos } from '../components/TabVideos';
import { TabExperts } from '../components/TabExperts';
import { TabHashtag } from '../components/TabHashtag';

export enum View { Trending, Videos, Assets, Hashtags, Experts }

export function Search({ activeLink, view } : { activeLink: string, view: number }) {
  const { query } = useParams()
  const [search, setSearch] = useState(query)
  const [isFocusedSearch, setIsFocusedSearch] = useState(false)
  const navigate = useNavigate()
  // const [view, setView] = useState<View>(View.Trending)
  const [suggestionsData, setSuggestionsData] = useState<any>([])

  const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.target as HTMLInputElement
    setSearch(value.slice(0, 100))
  }

  const { data: populars } = useGetPopularQuerySuggestion()
  const { data: recents, refetch } = useGetRecentQuerySuggestion()
  const { data: suggestions, mutate: getQuerySuggestion } = useGetQuerySuggestion()
  const { mutate: removeRecent } = useDeleteQuerySuggestion()
  const [recentsData, setRecentsData] = useState(recents)
  const handleRemoveRecent = (queryStr: string) => {
    setRecentsData(recents?.filter((r) => r.query !== queryStr))
    removeRecent(queryStr, {
      onSuccess() {
        refetch()
      },
    })
  }

  useEffect(() => {
    if (recents) {
      setRecentsData(recents)
    }
  }, [recents])

  useEffect(() => {
    if (search) {
      getQuerySuggestion(search)
      // setIsFocusedSearch(false)
    }
  }, [search])

  useEffect(() => {
    if (suggestions) {
      setTimeout(() => {
        setSuggestionsData(suggestions)
      }, 300)
    }
  }, [suggestions])

  useEffect(() => {
    setSearch(query)
    refetch()
  }, [query])

  /* useEffect(() => {
    if (search && search !== query) {
      // setIsFocusedSearch(true)
    } else {
      // setIsFocusedSearch(false)
      setView(View.Trending)
    }
  }, [search]) */

  const searchTo = useCallback((event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault()

      if (search) navigate(`/search/${search}`)
      setIsFocusedSearch(false)
    }
  }, [search])

  useEffect(() => {
    window.addEventListener('keypress', searchTo)

    return () => window.removeEventListener('keypress', searchTo);
  }, [search])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const items = [
    { title: 'Trending', id: View.Trending, link: '/search' },
    { title: 'Videos', id: View.Videos, link: '/search/videos' },
    { title: 'Assets', id: View.Assets, link: '/search/assets' },
    { title: 'Experts', id: View.Experts, link: '/search/experts' },
    { title: 'Hashtags', id: View.Hashtags, link: '/search/hashtags' },
  ]

  return (
    <Page activeLink={activeLink}>
      <div className={styles.container}>
        <div className={clsx(styles.searchContainer)}>
          <IconBack className={styles.back} onClick={() => navigate(-1)} />
          <Input
            icon={<IconSearch className={styles.prefix} />}
            suffix={search ? <IconClear className={styles.suffix} onClick={() => setSearch('')} /> : undefined}
            className={styles.searchInput}
            value={search}
            onChange={handleSearchChange}
            onFocus={() => {
              setIsFocusedSearch(true)
            }}
            onClick={() => {
              setIsFocusedSearch(true)
            }}
            onBlur={() => {
              setTimeout(() => {
                setIsFocusedSearch(false)
              }, 100)
            }}
            placeholder="Search on Beautify"
          />
        </div>
        {/* modal */}
        <div className={clsx(styles.searchDropdown, (isFocusedSearch) ? styles.searchDropdownActive : '', 'scroll')}>
          {
                recentsData
                  ?.filter((r) => r?.query.includes(search || ''))
                  .slice(0, 5)
                  .map((r) => (
                    <div
                      className={clsx(styles.searchRecent, styles.searchRecentItem)}
                    >
                      <IconRecent
                        onClick={() => {
                          navigate(`/search/${r?.query.replace('#', '')}`)
                          setSearch(r?.query)
                        }}
                      />
                      <span onClick={() => {
                        navigate(`/search/${r?.query.replace('#', '')}`)
                        setSearch(r?.query)
                      }}
                      >
                        {r?.query}
                      </span>
                      <IconRemove
                        className={styles.remove}
                        onClick={() => handleRemoveRecent(r?.query)}
                      />
                    </div>
                  ))
              }
          {search?.length ? '' : <h4>Popular Suggestions</h4>}
          {
                populars
                  ?.filter((r) => r?.includes(search || ''))
                  ?.map((p) => (
                    <div
                      className={styles.searchRecent}
                      onClick={() => {
                        navigate(`/search/${p.replace('#', '')}`)
                        setSearch(p)
                      }}
                    >
                      <IconPopular />
                      <span>{p}</span>
                    </div>
                  ))
              }
          {
                suggestionsData?.filter((p) => (p.length < 100))?.map((p) => (
                  <div
                    className={styles.searchRecent}
                    onClick={() => {
                      navigate(`/search/${p.replace('#', '')}`)
                      setSearch(p)
                    }}
                  >
                    <IconSuggestion />
                    <span>
                      {p}
                    </span>
                  </div>
                ))
              }
        </div>
        {/* modal */}
        {
          isFocusedSearch ? null : (
            <>
              <Tabs
                className={clsx(styles.tabs)}
                items={items}
                activeLink={activeLink}
                queryString={search ? `/${search}` : ''}
                inline
                links
              />
              { view === View.Trending && <TabTrending search={search || ''} /> }
              { view === View.Assets && <TabAsset search={search || ''} /> }
              { view === View.Videos && <TabVideos search={search || ''} /> }
              { view === View.Experts && <TabExperts search={search || ''} /> }
              { view === View.Hashtags && <TabHashtag search={search || ''} /> }
            </>
          )
        }

      </div>
    </Page>
  )
}
